import * as React from 'react';
import { compose } from 'recompose';
import { createStyles, withStyles } from '@material-ui/styles';
import cl from 'classnames';
import MaskedInput from 'react-text-mask';
import { border, toCssValue } from '@topconagriculture/theme';
import Caption from '../../Text/Caption';
const styles = (theme) => createStyles({
    maskedInputWrapper: {
        position: 'relative',
        marginBottom: theme.space.margin.default,
    },
    disabled: {
        opacity: 0.4,
        pointerEvents: 'none',
    },
    errorField: {
        borderColor: `${theme.color.error.main} !important`,
    },
    maskedInput: {
        backgroundColor: 'transparent !important',
        border: 'none',
        width: '100%',
        borderBottom: border(theme.color.grey.dark),
        padding: toCssValue([5, 0]),
        marginTop: 4,
        outline: 'none',
        height: 20,
        minHeight: 20,
        fontFamily: theme.font.family,
        fontSize: 16,
        '&:hover, &:focus': {
            borderBottom: border(theme.color.grey.dark, 2),
            padding: toCssValue([5, 0, 4]),
        },
        '&:focus, &:active': {
            outline: 'none',
        },
    },
    errorLabel: {
        color: theme.color.error.main,
    },
    error: {
        color: theme.color.error.main,
        fontSize: 11.2,
        position: 'relative',
        bottom: 4,
    },
});
const CustomMaskedInput = (props) => {
    const { classes, placeholder, input, meta, label, mask, disabled, testId = 'InnerShadow', required, ...other } = props;
    const isNotValid = meta.error && meta.visited;
    return (React.createElement("div", { "data-testid": `${testId}`, className: cl(classes.maskedInputWrapper, disabled ? classes.disabled : '', isNotValid ? classes.errorField : '') },
        React.createElement(Caption, { "data-testid": `${testId}-label`, className: isNotValid ? classes.errorLabel : '' },
            label,
            " ",
            required ? '*' : ''),
        React.createElement(MaskedInput, Object.assign({ "data-testid": `${testId}-input`, guide: true, mask: mask || false, placeholderChar: '_', placeholder: placeholder }, input, other, { className: classes.maskedInput })),
        isNotValid && (React.createElement(Caption, { "data-testid": `${testId}-error`, className: classes.error }, meta.error))));
};
export default compose(withStyles(styles))(CustomMaskedInput);
//# sourceMappingURL=MaskedInput.js.map